import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 988,
      width: 988,
    },
    dialogContent: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(2),
      padding: '8px 24px 24px',
    },
    title: {
      ...theme.typography.h2,
      textAlign: 'center',
    },
    widget: {},
  }),
  { name: 'CreateContentPopup' }
);
